<template>
    <div class="upload-img">
        <div class="upload-list">
            <!-- <viewer :images="imgData"> -->
            <div class="viewer-pane" v-viewer="{ shown: handleViewerShown }">
                <template v-for="(v, i) in imgData">
                    <div
                        class="upload-item list"
                        :style="{ background: 'url(' + v + ') no-repeat center center / 100%' }"
                        :key="i"
                    >
                        <!-- pdf -->
                        <div class="pdf-viewer" v-if="isPdf(v)">
                            <pdf-viewer :pdf="v"></pdf-viewer>
                        </div>

                        <!-- img -->
                        <!-- 图片做背景图处理： 预览按钮已隐式处理图片，防止viewer组件重复加载相同img  -->
                        <div class="op-btns">
                            <span class="view-btn iconfont el-icon-zoom-in">
                                <!-- 透明 img -->
                                <img class="view-mask-img" :src="v" />
                            </span>
                            <span class="delete-btn iconfont el-icon-delete" @click="handleDeleteImg(i)"></span>
                        </div>
                        <div
                            class="succ-icon"
                            :style="{ background: 'url(' + iconUploadSucc + ') no-repeat top right / 100%' }"
                        ></div>
                    </div>
                </template>

                <el-upload
                    class="upload-item"
                    :auto-upload="true"
                    :show-file-list="false"
                    :before-upload="processBeforeUpload"
                    :on-success="processSuccess"
                    :on-error="processError"
                    :on-progress="processProgress"
                    :headers="{ token: authToken }"
                    :action="action"
                    :multiple="multiple"
                    v-show="displayUpload"
                >
                    <i :class="'uploader-icon ' + (loading ? 'el-icon-loading' : 'el-icon-plus')"></i>
                </el-upload>
            </div>
        </div>

        <div class="upload-tip">只能上传jpg/png/jpeg/pdf文件，且不超过2M</div>
    </div>
</template>

<script>
import Request from '@/core/QuRequest';
import $util from '@/common/js/util';
import PdfViewer from './PdfViewer';
import * as $cache from '@/common/cache';
import IconUploadSucc from '@/assets/image/icon/upload-succ-icon.png';

const req = new Request();

export default {
    name: 'CM_UploadImg',
    components: { PdfViewer },
    computed: {
        displayUpload () {
            return this.limit <= 0 ? true : this.imgData.length < this.limit;
        }
    },
    props: {
        // 仅作单页组件复用时，数据标识; [optional]
        sign: {
            type: String,
            default: ''
        },
        // 关联数组
        imgs: {
            type: Array,
            default: () => []
        },
        // 限制数量，默认： -1 (<0)无限制
        limit: {
            type: Number,
            default: -1
        },
        // 支持多选
        multiple: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        imgs (v) {
            this.imgData = [...v];
        }
    },
    data () {
        return {
            iconUploadSucc: IconUploadSucc,
            action: req.getUrl(req.Apis.sales.common.uploadFile),
            imgData: [],
            loading: false,
            authToken: ($cache.localGet($cache.AUTH) || {}).token || ''
        };
    },
    methods: {
        // isPdf
        isPdf (url = '') {
            return /.(pdf)$/.test(url);
        },

        // 上传图片
        processSuccess (res) {
            this.loading = false;
            if (res.code === 200) {
                this.$message.success('上传成功');
                this.imgData = [...this.imgData, (res.data || {}).imageUrl || ''];
                this.$emit('upload', { imgs: this.imgData, sign: this.sign });
            } else {
                this.$message.error(res.message || '上传失败');
            }
        },

        // 监听上传进度
        processProgress (event, file, fileList) {
            this.loading = true;
        },

        // 监听上传失败
        // eslint-disable-next-line handle-callback-err
        processError (err, file, fileList) {
            this.loading = false;
            this.$message.error('上传失败');
        },

        // 监听上传前检查
        processBeforeUpload (file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            const isImg = /\/(jpg|png|jpeg|pdf)$/.test(file.type);

            if (!isImg) {
                this.$message.error('图片格式有误，格式支持jpg/png/jpeg/pdf');
            } else if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 2MB!');
            }

            return isImg && isLt2M;
        },

        // 拦截 viewer shown, 兼容pdf预览
        handleViewerShown () {
            const viewer = this.$el.querySelector('.viewer-pane').$viewer;
            const img = this.imgData[viewer.index] || '';
            const pdf = this.isPdf(img);

            if (pdf) {
                $util.openUrl(img, { newWin: true });
                viewer.hide();
            }
        },

        // 删除图片
        handleDeleteImg (i) {
            this.imgData.splice(i, 1);
            this.$emit('delete', { imgs: this.imgData, sign: this.sign });
        }
    }
};
</script>

<style lang="less" scoped>
.upload-img {
    .upload-list {
        position: relative;
        overflow: hidden;
        line-height: 0;
    }

    .upload-tip {
        font-size: 12px;
        color: #888;
        line-height: 20px;
        margin-bottom: 16px;
    }

    .upload-item {
        position: relative;
        display: inline-block;
        width: 144px;
        height: 144px;
        margin: 0 16px 16px 0;
        overflow: hidden;
        border: 1px dashed #ccc;
        border-radius: 6px;
        cursor: pointer;

        &.list {
            .succ-icon {
                display: block;
            }

            &:hover {
                .op-btns,
                &::before {
                    display: block;
                }
                .succ-icon {
                    display: none;
                }
            }
        }

        &:hover {
            border-color: #409eff;
        }

        &::before {
            display: none;
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.44);
        }

        .pdf-viewer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }

        .succ-icon {
            display: none;
            position: absolute;
            top: -1px;
            right: -1px;
            z-index: 2;
            height: 24px;
            width: 24px;
        }

        .op-btns {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 3;
            color: #fff;
            width: 100%;
            text-align: center;
            font-size: 30px;

            .iconfont {
                position: relative;
                font-size: 26px;
                margin: 0 12px;

                .view-mask-img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 2;
                    width: 100%;
                    opacity: 0;
                }
            }
        }

        .img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }

        .delete-icon {
            position: absolute;
            top: 0;
            right: 0;
            font-size: 24px;
            color: #e64545;
        }

        .uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 144px;
            height: 144px;
            line-height: 144px;
            text-align: center;
        }
    }
}
</style>
